import ValidationHelper from 'legacy/lut/classes/helpers/partner360/ValidationHelper'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { FC, useCallback, useEffect } from 'react'

import { FormDropdown, updateInvalidData } from 'cng-common/features/form'
import { ValidationType } from 'cng-common/features/form/configs'

import { investmentSources, investmentSourcesCrud } from './configs'
import { TInvestmentSourceValue } from './models'

interface IInvestmentSourceProps {
  initialValue?: TInvestmentSourceValue
  className?: string
  formKey: string
  isDisabled?: boolean
  label?: string
  placeholder?: string
}

export const InvestmentSource: FC<IInvestmentSourceProps> = ({
  initialValue = '',
  className,
  formKey,
  isDisabled,
  label,
  placeholder,
}) => {
  const dispatch = useAppDispatch()

  const handleValidate = useCallback(
    (value: string) => ValidationHelper.checkDropdown(value, investmentSources, 'value'),
    []
  )

  useEffect(() => {
    return () => {
      dispatch(
        updateInvalidData({
          key: formKey,
          field: 'hpInvestmentSum',
          validationMessage: '',
        })
      )
      dispatch(
        updateInvalidData({
          key: formKey,
          field: 'hpInvestmentSource',
          validationMessage: '',
        })
      )
    }
  }, [dispatch, formKey])

  return (
    <div className={className}>
      <FormDropdown
        isStatic
        isDisabled={isDisabled}
        isRequired
        formKey={formKey}
        field="hpInvestmentSource"
        defaultValue={initialValue}
        source={investmentSourcesCrud}
        caption="value"
        label={label}
        placeholder={placeholder}
        onValidate={handleValidate}
        validationType={ValidationType.ONCHANGE}
      />
    </div>
  )
}

InvestmentSource.displayName = 'InvestmentSource'
